import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DocumentsBaseComponent } from '@app/core/components/documents-base/documents-base.component';
import * as fromRoot from '@app/store/reducers';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';

@Component({
  selector: 'am-document-menu',
  templateUrl: './document-menu.component.html',
  styleUrl: './document-menu.component.scss',
  imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, MatProgressSpinner, AsyncPipe, TranslocoPipe],
  standalone: true,
})
export class DocumentMenuComponent extends DocumentsBaseComponent {
  constructor() {
    const store = inject<Store<fromRoot.State>>(Store);
    const translocoService = inject(TranslocoService);

    super(store, translocoService);
  }
}
